import React from 'react';
import ReactDOM from "react-dom";
import Carousel from 'react-material-ui-carousel'
import { Box, Button } from '@mui/material'
import Grid from '@mui/material/Grid';
import {IntlProvider} from 'react-intl';
import {FormattedMessage} from 'react-intl';
import English from '/static/i18n/en.json';
import Bengali from '/static/i18n/bn.json';

import ReactHtmlParser from 'react-html-parser'; 

const locale = navigator.language;


const HtmlDisplay = (props) => {
    return (
        <>
        { ReactHtmlParser (props.data) }
      </>
        
    )
};

export default HtmlDisplay;